// extracted by mini-css-extract-plugin
module.exports = {"totop":"ToTop_totop__2J6_1","jump":"ToTop_jump__myYVl","pulse":"ToTop_pulse__3cvaN"};